/**
 * Theme: the shared product card's bookmark, on every surface.
 *
 * EXTRACTED FROM assets/core-rail.js, AND THE EXTRACTION IS THE POINT.
 * The toggle used to be a private method on the <core-rail> custom element,
 * delegated onto that host. That worked for the only surface that existed at
 * the time, the PDP recommendation rails, and was silently dead everywhere
 * else: a card rendered outside a rail had a bookmark that painted nothing and
 * saved nothing, with no error. The wishlist page is the first grid of cards
 * with no rail around them, and the collection grid and search will be the
 * next two.
 *
 * Bound at DOCUMENT level, so it does not care how a card reached the page:
 * server-rendered, morphed in by the Section Rendering API, or injected by
 * assets/core-wishlist-page.js. There is nothing to re-bind and nothing to
 * initialise per surface.
 *
 * THE KEY HAS THREE PARTS, AND THE BUTTON DECIDES ALL THREE.
 * window.WISH keys on `variantId|colour|size`. A card in a rail or a grid saves
 * item-only (blank colour, blank size) because a card cannot know which variant
 * the shopper wants, and that entry is deliberately distinct from a PDP save
 * that captured one. A card ON THE WISHLIST is different: it stands for one
 * stored key, so it carries data-wish-colour and data-wish-size and toggling it
 * removes exactly that entry rather than an item-only one that may not exist.
 * Absent attributes mean blank, so every other surface keeps its old behaviour
 * without opting in.
 *
 * Reads window.WISH only. It never touches localStorage, so the header badge,
 * the rails and the wishlist page cannot disagree about what is saved.
 */
(function () {
  'use strict';

  var SELECTOR = '[data-core-card-save]';

  /**
   * Paint one bookmark: filled when saved, plus the matching aria state.
   * Moved here verbatim from core-rail.js so the two cannot drift.
   */
  function paint(button, saved) {
    var svg = button.querySelector('svg');
    if (svg) svg.setAttribute('fill', saved ? 'currentColor' : 'none');
    button.setAttribute('aria-pressed', saved ? 'true' : 'false');

    var label = button.getAttribute('aria-label') || '';
    var name = label.replace(/^(Save|Saved\. Remove) /, '').replace(/ from saved items$/, '');
    button.setAttribute('aria-label', saved ? 'Saved. Remove ' + name + ' from saved items' : 'Save ' + name);
  }

  /** The three key parts this button stands for. Blank is meaningful. */
  function partsOf(button) {
    return {
      id: button.getAttribute('data-variant-id') || '',
      colour: button.getAttribute('data-wish-colour') || '',
      size: button.getAttribute('data-wish-size') || '',
    };
  }

  /** Repaint every bookmark currently in the document, or within a scope. */
  function paintAll(scope) {
    if (!window.WISH) return;
    var root = scope || document;
    var buttons = root.querySelectorAll(SELECTOR);
    for (var i = 0; i < buttons.length; i++) {
      var parts = partsOf(buttons[i]);
      paint(buttons[i], Boolean(parts.id) && window.WISH.has(parts.id, parts.colour, parts.size));
    }
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest ? event.target.closest(SELECTOR) : null;
    if (!button) return;

    // The card is a stretched link and the bookmark sits above it on z-index 1,
    // so the click lands on the button rather than the anchor. preventDefault
    // is belt and braces for any surface that wraps the card differently.
    event.preventDefault();

    var parts = partsOf(button);
    if (!parts.id || !window.WISH) return;

    paint(button, window.WISH.toggle(parts.id, parts.colour, parts.size));
  });

  // Any change anywhere, including another tab, repaints every card on screen.
  document.addEventListener('wishlist:change', function () {
    paintAll();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      paintAll();
    });
  } else {
    paintAll();
  }

  // Published so a surface that injects cards can paint them immediately
  // rather than waiting for the next wishlist:change.
  window.CORECardSave = { paint: paint, paintAll: paintAll, partsOf: partsOf };
})();
